class ModalTrigger {
  constructor() {
    setTimeout(() => {
      this.btnClose = document.querySelector('[close-trigger-body]')
      this.btnOpen = document.querySelector('[open-trigger-body]')
      this.trigger = document.getElementById('trigger-body')
      this.isOpen = true
      this.modal = new ModalCTA()

      this.handleVisibility()
      
      this.handleTrigger()
      this.handleOpenModal()
    }, 500)
  }

  handleVisibility() {
    const addClass = () => {
      document.getElementById('whats-cta')
      .classList.add('show')
      document.getElementById('cta-trigger')
        .classList.add('show')
    }
    
    window.pageYOffset > 300 ? addClass() : false
    window.addEventListener('scroll', () => window.pageYOffset > 300 ? addClass() : false)
  }

  handleTrigger() {
    this.btnClose.addEventListener('click', () => {
      this.trigger.style.opacity = 0
      this.isOpen = !this.isOpen
    })

    this.btnOpen.addEventListener('click', () => {
      if( !this.isOpen ) {
        this.trigger.style.opacity = 1
        this.isOpen = !this.isOpen
      }
    })
  }

  handleOpenModal() {
    const modalTriggers = document.querySelectorAll('[open-modal-cta]')
    if( modalTriggers ) {
      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.modal.open()
        })
      })
    }
  }
}

class ModalCTA {
  constructor() {
    this.self = document.getElementById('modal-cta')
    this.closeTriggers = document.querySelectorAll('[modal-close]')

    this.handleClose()
    this.handleTabs()
  }

  open() {
    this.self.classList.add('open')
  }

  handleClose() {
    this.closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        console.log(e.target)
        e.target.getAttribute('id') == 'modal-overlay' ? (
          this.self.classList.remove('open')
        ) : false
      })
    })

    document.onkeydown = key => {
      if( this.self.classList.contains('open') && key.key === 'Escape' ) {
        this.self.classList.remove('open')
      }
    }
  }

  handleTabs() {
    const tabs = document.querySelectorAll('[modal-tab]')
    const contents = document.querySelectorAll('.modal-content')

    tabs[0].classList.add('active')
    contents[0].classList.add('active')

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = document.getElementById(tab.getAttribute('data-open'))

        tabs.forEach(tab => {
          tab.classList.contains('active') ? tab.classList.remove('active') : false
        })

        contents.forEach(content => {
          content.classList.contains('active') ? content.classList.remove('active') : false
        })

        tab.classList.add('active')
        target.classList.add('active')
      })
    })
  }
}

window.addEventListener('DOMContentLoaded', new ModalTrigger())